<ui-pagination
  class="reflection-pagination"
  [uiPageIndex]="pageIndex"
  [uiTotal]="total"
  [uiPageSize]="pageSize"
  [uiItemRender]="renderItemTemplate"
  [uiShowTooltip]="false"
  (nzPageIndexChange)="handlePageIndexChange($event)"></ui-pagination>
<ng-template #renderItemTemplate let-type let-page="page">
  <ng-container [ngSwitch]="type">
    <a *ngSwitchCase="'page'">{{ page }}</a>
    <a *ngSwitchCase="'prev'">
      <i ui-icon uiType="chevron-left-big"></i>
    </a>
    <a *ngSwitchCase="'next'">
      {{ "next" | localize }}
      <i ui-icon uiType="chevron-right-big"></i>
    </a>
    <a *ngSwitchCase="'prev_5'">...</a>
    <a *ngSwitchCase="'next_5'">...</a>
  </ng-container>
</ng-template>
